import type { SeoProps } from 'src/types';

export const seo: SeoProps = {
  title: 'SEEK - the best employment site in the Asia Pacific',
  description:
    'Discover your next job, career advice, and more. Hire for your business with expert advice, insights and support from our local teams.',
  url: 'https://www.seek.com/',
  robots: 'index,follow',
};
